import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import "rxjs/Rx";
import { Subject }    from 'rxjs/Subject';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from "../auth.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";

import { SharedModule, NumPipe, UtilsService } from "../shared/shared.module";

declare let swal:any;


@Component({
  selector: 'app-list-promotion',
  templateUrl: './list-promotion.component.html',
  styleUrls: ['./list-promotion.component.css']
})
export class ListPromotionComponent implements OnInit {
  page: number = 1;
  totalPage: number = 1;
  search: string = "";
  limit: number = 10;
  sortBy: string = 'id';
  revert: boolean = false;
  txtQueryChanged: Subject<string> = new Subject<string>();
  isLoading: boolean = false;

  errors = {};
  promotions:any = null;

  environment: any;

  possibleStatus: any = [
    {value: 'IN_COMING', text: 'Promotions à venir'},
    {value: 'IN_PROGRESS', text: 'Promotions en cours'},
    {value: 'DONE', text: 'Promotions terminée'}
  ];

  selectedStatus: string = 'IN_PROGRESS';

  constructor(
    private numPipe: NumPipe,
    private authService: AuthService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    public utils: UtilsService
  ) { }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      else
        this.utilsService.scrollTop();
    });

    this.route.queryParamMap.subscribe(query => {
      if (query['params'].status)
        this.selectedStatus = query['params'].status;
    });

    this.authService.getSession();

    this.txtQueryChanged
	  .debounceTime(500) // wait x sec after the last event before emitting last event
	  .distinctUntilChanged() // only emit if value is different from previous value
	  .subscribe(model => {
      this.search = model;
      this.page = 1;
      this.getPromotions();
    });
    this.getPromotions();
  }

  getPromotions(resetPage = false) {
    this.isLoading = true;
    this.errors = {};

    if (resetPage == true)
      this.page = 1;

    var query = "?search=" + this.search + "&limit=" + this.limit + "&page=" + this.page + "&sortBy=" + this.sortBy + "&revert=" + this.revert + '&status=' + this.selectedStatus ;
    if (this.authService.connectedAs.admin == false)
      query += "&connectedAsId=" + this.authService.connectedAs.id;

    this.http.get(environment.API_PATH + '/product/discount' + query, {withCredentials: true})
		.subscribe(
      data => {
        this.promotions = data['rows'];
        this.totalPage = Math.ceil(data['count'] / this.limit) ;
        this.isLoading = false;
      },
      err => {
        var errors = err.error;
        this.isLoading = false;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  changePage(num: number, n:number = null): void {
    if (n)
      this.page = this.numPipe.transform(num, n);
    else
      this.page = num;

    this.getPromotions();
  };

  sortTable(sortBy: string): void {
    if (this.sortBy === sortBy)
      this.revert = !this.revert;
    else
      this.revert = false;
    this.sortBy = sortBy;
    this.getPromotions();
  }

  onSearchChange(query:string) {
    this.txtQueryChanged.next(query);
  }

  seePromotion(id: number): void {
    this.router.navigate(['detail', id], {relativeTo: this.route});
  }

  seeTargets(productId) {
    this.http.get(environment.API_PATH + '/product/target/' + productId, {withCredentials: true})
		.subscribe(
      data => {
        this.isLoading = false;
        var pharmaStr = "";
        for (let i in data['rows']) {
          if (data['rows'][i].pharmacy) {
            pharmaStr += '<tr><td class="text-left">' + data['rows'][i].pharmacy.cip + '</td><td class="text-left">' + data['rows'][i].pharmacy.name + '</td></tr>';
          }
          else {
            pharmaStr += '<tr><td class="text-left"> - </td><td class="text-left">Pharmacie supprimée</td></tr>';
          }
        }
        swal({
          title: 'Liste des pharmacies',
          html: '<div class="col-xs-12 table-responsive no-padding" style="max-height: 500px">' +
          '<table class="table table-striped primary sortable-table">' +
          '<div class="col-xs-12 table-responsive no-padding">' +
          '<table class="table table-striped primary sortable-table">' +
          '<thead>' +
          '<tr>' +
          '<th>CIP</th>' +
          '<th>Nom de la pharmacie</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>' +
          pharmaStr +
          '</tbody>' +
          '</table>',
          type: 'info',
          customClass: 'pharma-list-modal'
        }).then(() => {
        }, () => {
        });
      },
      err => {
        this.isLoading = false;
        if (err.status === 401) {

          this.router.navigate(['/connexion']);
        } else if (err.status === 404) {
          this.utilsService.displayNotif("Cette campagne n'existe pas", "danger");
          this.router.navigate(['../..'], {relativeTo: this.route});
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/list-promotion/list-promotion.component.ts